import type { GetOutgoingTransferResponseDto } from '../schemas/generated';

type OutgoingTransferStatus = NonNullable<GetOutgoingTransferResponseDto['data']['status']>;

const CANCELLED_OUTGOING_TRANSFER_STATUS = 'cancelled' satisfies OutgoingTransferStatus;

export const isCancelledOutgoingTransferStatus = (status: unknown): boolean =>
  typeof status === 'string' && status.trim().toLowerCase() === CANCELLED_OUTGOING_TRANSFER_STATUS;
